/**
 * Makes the specified custom React propType chainable with an "isRequired" field.
 * @param {function} - The custom React propType that needs to be chainable.
 * @returns {function}
 */
function createChainablePropType(customPropType) {
  var checkType = (isRequired, props, propName, componentName) => {
    if (!props[propName]) {
      if (isRequired) {
        return new Error("Required propType '".concat(propName, "' was not specified in '").concat(componentName, "'."));
      }
      return null;
    }
    return customPropType(props, propName, componentName);
  };
  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
}
export default createChainablePropType;